import styled from 'styled-components'

import kevinAndTruck from 'images/trailer-hitch/kevin-and-track.png'
import thumbsUp from 'images/trailer-hitch/thumbs-up.png'
import alert from 'images/trailer-hitch/alert.png'

import { Container, Module, Slide, Agree } from 'components/pages/certifications/framework'
import { Spacer, Text, Button } from 'roadie-ui'
import { TRAINING_CERTS } from 'util/constants'
import { LocalizedRichText, useLocalization, LocalizedText } from 'localization'

const ImgContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`

const List = styled.ul`
  margin: 0;
  padding-left: 22px;
`

const labelKeys = [
  'dweb_certifications_trailer_hitch_agree_vehicle_has_hitch',
  'dweb_certifications_trailer_hitch_agree_vehicle_can_tow_more_than_1500_lbs',
  'dweb_certifications_trailer_hitch_agree_safe_driving_with_trailer',
]

const TrailerHitchPage = () => {
  const { t } = useLocalization()

  return (
    /* FIXME: @missingRoadieUI Module Container */
    <Container title={t('dweb_certifications_trailer_hitch_trailer_required_gigs')}>
      {/* FIXME: @missingRoadieUI Module */}
      <Module certification={TRAINING_CERTS.TRAILER_HITCH}>
        <Slide>
          <ImgContainer>
            <img src={kevinAndTruck} alt={t('dweb_certifications_trailer_hitch_alt_kevin_and_truck')} />
          </ImgContainer>
          <Spacer $height="3.2rem" />
          <Text.Overline $fontWeight="500" $color="primary-base">
            <LocalizedText translationKey="dweb_certifications_trailer_hitch_what_need_know_about" />
          </Text.Overline>
          <Spacer $height=".4rem" />
          <Text.H4 $color="neutral-black">
            <LocalizedText translationKey="dweb_certifications_trailer_hitch_trailer_required_gigs" />
          </Text.H4>
          <Spacer $height=".8rem" />
          <Text.Body2 $color="neutral-black">
            <LocalizedText translationKey="dweb_certifications_trailer_hitch_intro" />
          </Text.Body2>
          <Spacer $height="3.2rem" />
        </Slide>

        <Slide>
          <ImgContainer>
            <img src={alert} alt={t('dweb_certifications_trailer_hitch_alt_alert')} />
          </ImgContainer>
          <Spacer $height="3.2rem" />
          <Text.H4 $color="neutral-black">
            <LocalizedText translationKey="dweb_certifications_trailer_hitch_requirements_trailer_required_gigs" />
          </Text.H4>
          <Spacer $height="1.6rem" />
          <Text.Body2 $color="neutral-black">
            <LocalizedText translationKey="dweb_certifications_trailer_hitch_requirements_intro" />
          </Text.Body2>
          <Spacer $height="1.6rem" />
          {/* FIXME: @missingRoadieUI List */}
          <List>
            <li>
              <Text.Body2 $color="neutral-black">
                <LocalizedRichText
                  translationKey="dweb_certifications_trailer_hitch_must_have_trailer_unless_gig_marked_as_strong"
                  params={{
                    strongText1: (
                      <strong>
                        <LocalizedText translationKey="dweb_certifications_trailer_hitch_hitch_ok" />
                      </strong>
                    ),
                  }}
                />
              </Text.Body2>
            </li>
            <Spacer $height="1.6rem" />
            <li>
              <Text.Body2 $color="neutral-black">
                <LocalizedText translationKey="dweb_certifications_trailer_hitch_vehicle_must_have_hitch" />
              </Text.Body2>
            </li>
            <Spacer $height="1.6rem" />
            <li>
              <Text.Body2 $color="neutral-black">
                <LocalizedText translationKey="dweb_certifications_trailer_hitch_vehicle_must_able_tow_more_than_1500lbs" />
              </Text.Body2>
            </li>
            <Spacer $height="1.6rem" />
            <li>
              <Text.Body2 $color="neutral-black">
                <LocalizedText translationKey="dweb_certifications_trailer_hitch_should_feel_safe_comfortable_driving_trailer" />
              </Text.Body2>
            </li>
          </List>
          <Spacer $height="2.4rem" />
          <Text.Body2 $color="neutral-black">
            <LocalizedRichText
              translationKey="dweb_certifications_trailer_hitch_customers_who_post_gigs_labeled_strong_text1_may"
              params={{
                strongText1: (
                  <strong>
                    <LocalizedText translationKey="dweb_certifications_trailer_hitch_trailer_required_hitch_ok" />
                  </strong>
                ),
              }}
            />
          </Text.Body2>
          <Spacer $height="2.4rem" />
          <Text.Body2 $color="neutral-black">
            <LocalizedText translationKey="dweb_certifications_trailer_hitch_rental_cost_disclaimer" />
          </Text.Body2>
          <Spacer $height="3.2rem" />
        </Slide>

        <Slide>
          <Text.H5 $color="neutral-black" $fontWeight="bold">
            <LocalizedText translationKey="dweb_certifications_mail_innovations_please_confirm" />
          </Text.H5>
          <Spacer $height=".8em" />
          <Text.Body2 $color="neutral-black">
            <LocalizedRichText
              translationKey="dweb_certifications_trailer_hitch_completion_acknowledgement"
              params={{
                strongText1: (
                  <strong>
                    <LocalizedText translationKey="dweb_certifications_trailer_hitch_trailer_required_hitch_ok" />
                  </strong>
                ),
              }}
            />
          </Text.Body2>
          <Spacer $height="2.4rem" />
          {labelKeys.map((labelKey) => (
            <Agree key={`agree-${labelKey}`} toKey={labelKey} />
          ))}
          <Spacer $height="3.2rem" />
        </Slide>

        <Slide>
          <ImgContainer>
            <img src={thumbsUp} alt={t('dweb_certifications_trailer_hitch_alt_thumbs_up')} />
          </ImgContainer>
          <Spacer $height="3.2rem" />
          <Text.H4 $color="neutral-black">
            <LocalizedText translationKey="dweb_certifications_prop22_prop22_great_job" />
          </Text.H4>
          <Spacer $height=".8rem" />
          <Text.Body2 $color="neutral-black">
            <LocalizedRichText
              translationKey="dweb_certifications_trailer_hitch_can_now_offer_any_gig_labeled_strong_text1"
              params={{
                strongText1: (
                  <strong>
                    <LocalizedText translationKey="dweb_certifications_trailer_hitch_trailer_required_hitch_ok" />
                  </strong>
                ),
              }}
            />
          </Text.Body2>
          <Spacer $height="2.4rem" />
          <Text.Body2 $color="neutral-black">
            <LocalizedText translationKey="dweb_certifications_trailer_hitch_if_have_own_personal_trailer_want_eligible_all" />
          </Text.Body2>
          <Spacer $height="5rem" />
          <Button.A.Secondary href="https://roadie.typeform.com/to/KFPl98ht" target="_blank" $width="100%">
            <LocalizedText translationKey="dweb_certifications_trailer_hitch_add_trailer_details" />
          </Button.A.Secondary>
          <Spacer $height="3.2rem" />
        </Slide>
      </Module>
    </Container>
  )
}

export default TrailerHitchPage
